export const Confirmation = () => {
  return (
    <div style={{ padding: "20px 10px" }}>
      <h1>Let's set up your store</h1>
      <div>Step 2: API Authorization</div>
      <div>
        We, Refund Pro, will need access to be authorized by you as a developer
        in Seller Central. This authorization will allow the audit to run via
        Amazon API.
      </div>
      <br></br>
      <br></br>
      <div>A- Open your Main Seller Central Account</div>
      <div>
        In a separate Browser Tab, please log in to your Main Seller Central
        Account. You will need to use your Primary User Login Credentials.
      </div>
      <br></br>
      <div>B. Authorize and Store Registration</div>
      <div>
        Once logged in, click AUTHORIZE* to grant Refund Pro App access to your
        store data.
      </div>
      <br></br>
      <br></br>
      <div>Still Need Help? Email us at office@refundprollc.com</div>
      <br></br>
      <br></br>
      <div>* Link to the following adress:</div>
      <a
        style={{
          fontSize: "1rem",
          color: "blue",
        }}
        href="https://sellercentral.amazon.com/apps/authorize/consent?application_id=amzn1.sellerapps.app.c864691e-efa0-426e-9ced-edc885a77fe5"
        target="_blank"
        rel="noreferrer"
      >
        {" "}
        https://sellercentral.amazon.com/apps/authorize/consent?application_id=amzn1.sellerapps.app.c864691e-efa0-426e-9ced-edc885a77fe5
      </a>
    </div>
  );
};
